import React from 'react';
import { TypographyBody, Notification, BellIcon } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelFlightsUnavailable() {
    const { resourceStrings: { HOLIDAY_FLIGHTS_UNAVAILABILITY_SUB_HEADING, HOLIDAY_FLIGHTS_UNAVAILABILITY_HEADING }, } = useGlobalContext();
    return (React.createElement(Notification, { color: "warning", icon: React.createElement(BellIcon, null) },
        React.createElement(TypographyBody, { weight: "bold" }, HOLIDAY_FLIGHTS_UNAVAILABILITY_HEADING),
        HOLIDAY_FLIGHTS_UNAVAILABILITY_SUB_HEADING));
}
